import { DialogActionsProps, DialogActions } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogActionsStyled = styled(DialogActions)<DialogActionsProps>(({ theme }) => ({
  '&.MuiDialogActions-root': {
    padding: `${theme.spacing(2)} 0 0 0`,
  },
}));
